
export const isUserActiveOnTab = (): boolean =>
    typeof document !== "undefined" &&
    document.visibilityState === "visible" &&
    document.hasFocus() &&
    typeof window !== "undefined" &&
    window.outerHeight > 0;

export const showBrowserNotification = (title: string, body: string) => {
    if (isUserActiveOnTab()) return;
    if (typeof window === "undefined" || !("Notification" in window)) return;

    const fire = () => new Notification(title, { body, icon: "/favicon.ico", badge: "/favicon.ico" });

    if (Notification.permission === "granted") fire();
    else if (Notification.permission !== "denied") {
        Notification.requestPermission().then((p) => p === "granted" && fire());
    }
};

